import React from 'react';
import { NavBar } from '../components/NavBar';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { HowItWorks } from '../components/HowItWorks';
import { IndustriesServed } from '../components/IndustriesServed';
import { ServiceAreas } from '../components/ServiceAreas';
import { Testimonials } from '../components/Testimonials';
import { ContactBanner } from '../components/ContactBanner';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="w-full min-h-screen overflow-x-hidden" data-id="element-202">
      <NavBar data-id="element-203" />
      <main data-id="element-204">
        <HeroSection data-id="element-205" />
        <ServicesSection data-id="element-206" />
        <WhyChooseUs data-id="element-207" />
        <HowItWorks data-id="element-208" />
        <IndustriesServed data-id="element-209" />
        <ServiceAreas data-id="element-210" />
        <Testimonials data-id="element-211" />
        <ContactBanner data-id="element-212" />
      </main>
      <Footer data-id="element-213" />
    </div>;
}